import type React from 'react';

import cn from 'classnames';

import { Link } from 'libs/router/Link';
import { useRouter } from 'libs/router/useRouter';

import { filterColumnsByLocale } from 'features/layout/routeLocaleAvailability';

import styles from './HeaderMenu.module.scss';

import type { MenuColumn } from './HeaderMenu.types';

interface Props {
  columns: MenuColumn[];
  columnClassName: string;
  onCloseMenu: () => void;
}

const Div = (props: React.HTMLAttributes<HTMLDivElement>) => <div {...props} />;

export const MenuColumns = ({ columns, columnClassName, onCloseMenu }: Props) => {
  const { query } = useRouter();
  const lang = (query.lang as string) || 'en';

  return (
    <>
      {filterColumnsByLocale(columns, lang).map(({ title, continuation, items }, index) => (
        <div key={`${title}-${index}`} className={columnClassName}>
          <span className={cn(styles.platformColumnTitle, continuation && styles.platformColumnTitleHidden)}>
            {title}
          </span>

          {items.map(({ navigation, label, description, disabled }) => {
            const ItemComponent = navigation && !disabled ? Link : Div;
            const linkProps = navigation && !disabled ? { route: navigation, onClick: onCloseMenu } : {};

            return (
              <ItemComponent
                key={navigation ?? label}
                className={cn(styles.platformColumnItem, disabled && styles.platformColumnItemDisabled)}
                {...(linkProps as any)}
              >
                <span className={styles.platformColumnItemText}>
                  {label}
                  {description && <span className={styles.platformColumnItemDescription}>{description}</span>}
                </span>
              </ItemComponent>
            );
          })}
        </div>
      ))}
    </>
  );
};
